"use client";

import { Send } from "lucide-react";
import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KolaborasiPublik() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="191879" id="ajakan-mengirim-opini" className="w-full bg-accent py-16 md:py-24 lg:py-32 overflow-hidden border-y border-muted">
      <div ref={ref} className={`container mx-auto px-6 md:px-8 text-center max-w-3xl lg:max-w-4xl transition-all duration-[600ms] ease-in-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 md:translate-y-8"}`}>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-secondary mb-6 tracking-tight leading-tight font-sans">
          Suarakan Pemikiran Anda
        </h2>
        
        <p className="text-base sm:text-lg md:text-xl text-muted-foreground mb-8 md:mb-10 max-w-2xl mx-auto font-sans leading-relaxed">
          Kami mengundang para intelektual dan warga untuk berkontribusi dalam membangun narasi publik yang lebih bermakna melalui opini dan gagasan.
        </p>
        
        <Button asChild variant="outline" size="lg" className="bg-primary text-primary-foreground border-none hover:bg-primary/90 hover:scale-[1.02] transition-all duration-300 rounded-md px-6 py-4 md:px-8 md:py-5 text-base md:text-lg font-semibold h-auto shadow-md">
          <Link to="#">
            <Send className="mr-2 h-5 w-5" />
            Kirim Opini Sekarang
          </Link>
        </Button>
      </div>
    </section>;
}